import BaseModel from "../base/BaseModel.model";
import BudgetItem from "./budgetItem.model";
import PorposalBudgetSubItem from './porposalBudgetSubItem.model';
import ProposalBudgetItemExecution from './proposalBudgetItemExecution.model';

export default class PorposalBudgetItem extends BaseModel {
  public budgetExpenseId?: number;
  public budgetItemId?: number;
  public budgetItem: BudgetItem | null = new BudgetItem();

  public porposalBudgetSubItems: Array<PorposalBudgetSubItem> = [];
  public proposalBudgetItemsExecution: Array<ProposalBudgetItemExecution> = [];

  constructor(){
     super();
     this.init();
  }

  init() {
    this.budgetExpenseId = 0;
    this.budgetItemId = 0;
    this.porposalBudgetSubItems = [];
    this.proposalBudgetItemsExecution = [];
    this.budgetItem = new BudgetItem();
  }
}
